import { useEffect, useState } from 'react'
import { Title } from './Title'
import { Textarea } from './Textarea'
import { ApprovalPendingBlock } from './ApprovalPendingBlock'
import { Error } from './Error'
import { usePostApiV1AccountsAddReasonMutation } from '@wellesley/openapi'
import { ButtonLoader } from '@wellesley/ui'
import { useSignUpHash } from '../hooks/useSignUpHash'
import { getErrorMsg } from '@wellesley/error-kit'
import { useFinishSignup } from '../hooks/useFinishSignup'
import { useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'
import { SignUpStages } from '../SignUpStages'

export const RequestApprovalBlock = () => {
  const [value, setValue] = useState('')
  const hash = useSignUpHash()
  const { finishSignup } = useFinishSignup()

  const [addReason, { isLoading, isSuccess, isError, error, data }] =
    usePostApiV1AccountsAddReasonMutation()

  const handleClick = () => {
    hash && void addReason({ signupReasonParams: { hash, reason: value } })
  }

  useEffect(() => {
    if (isSuccess && value && data) {
      void finishSignup(data)
      setValue('')
    }
  }, [isSuccess, setValue, finishSignup, value, data?.hash])

  return (
    <div className="mx-auto flex w-[450px] flex-col items-center justify-center">
      <SignUpStages position={3} />
      <Title />
      <div className="mt-s w-[450px]">
        <Textarea value={value} onChange={setValue} />
        {isError && <Error>{getErrorMsg(error)}</Error>}
      </div>
      <div className="flex w-full justify-end py-s">
        <ButtonLoader
          isLoading={isLoading}
          size="m"
          variant="primary"
          disabled={!value}
          onClick={handleClick}
        >
          Request to Join
        </ButtonLoader>
      </div>
    </div>
  )
}

export const Approval = () => {
  const signupFields = useSelector(authSlice.selectors.selectSignupFields)

  return signupFields?.nextStep !== 'ADMIN' ? (
    <ApprovalPendingBlock />
  ) : (
    <RequestApprovalBlock />
  )
}
